@if (publicMode || showChatButton) {
  <div class="wp-intercom-slack bottom-right" id="wp-intercom-slack">
    <div class="wpic-frame" [ngClass]="{ active: isActive }">
      @if (urlSafe) {
        <iframe
          class="tw:z-[999999999999999999] tw:border-0 tw:rounded-md tw:bg-white tw:shadow-[0_2px_8px_rgba(0,0,0,0.09),0_4px_50px_rgba(0,0,0,0.24)] tw:p-0"
          height="100%"
          width="100%"
          [src]="urlSafe"
        ></iframe>
      }
    </div>

    <div class="wpic-launcher" (click)="toggleChat()">
      <div class="wpic-launcher-open" [ngStyle]="{ opacity: isActive ? 0 : 1 }">
        <svg height="34" viewBox="0 0 17 17" width="34" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.5 12c2.48 0 4.5-2.02 4.5-4.5v-3C13 2.19 11.244.303 9 .05V0H8v.05C5.756.304 4 2.19 4 4.5v3C4 9.98 6.02 12 8.5 12zM6 2.06V4h1V1.352c.312-.15.646-.25 1-.3V4h1V1.05c.354.052.688.152 1 .302V4h1V2.06c.617.63 1 1.49 1 2.44V5H5v-.5c0-.95.383-1.81 1-2.44zM5 6h7v1.5c0 1.93-1.57 3.5-3.5 3.5S5 9.43 5 7.5V6zm10 1v3.25c0 2.067-2.02 3.75-4.5 3.75H9v3H8v-3H6.5C4.02 14 2 12.317 2 10.25V7h1v3.25C3 11.767 4.57 13 6.5 13h4c1.93 0 3.5-1.233 3.5-2.75V7h1z"
          ></path>
        </svg>
      </div>
      <div class="wpic-launcher-close" [ngStyle]="{ opacity: isActive ? 1 : 0 }">
        <svg height="26" viewBox="0 0 17 17" width="26" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.207 8.5l6.646 6.646-.707.707L8.5 9.207l-6.646 6.646-.707-.707L7.793 8.5 1.146 1.854l.707-.707L8.5 7.793l6.646-6.646.707.707L9.207 8.5z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
}
